import React, { Component } from "react";
import PropTypes from "prop-types";
import { translate } from "react-polyglot";
import classNames from "classnames";
import LoadingSpinner from "./LoadingSpinner";
import ProfileOption from "./ProfileOption";
import { PrimaryButton, SecondaryButton } from "./buttons";
import { BaseForm } from "./form";

import "./Profile.css";

class Profile extends Component {
  constructor(props) {
    super(props);

    this.handleEditProfile = this.handleEditProfile.bind(this);
    this.handleEnterManageMode = this.handleEnterManageMode.bind(this);
    this.handleLeaveManageMode = this.handleLeaveManageMode.bind(this);
    this.handleSelectProfile = this.handleSelectProfile.bind(this);
    this.handleChangeProfile = this.handleChangeProfile.bind(this);
  }

  handleEditProfile(profileId) {
    this.props.onEditProfile(profileId);
  }

  handleSelectProfile(profileId) {
    this.props.onSelectProfile(profileId);
  }

  handleEnterManageMode() {
    this.props.onEnterManageMode();
  }

  handleLeaveManageMode() {
    this.props.onLeaveManageMode();
  }

  handleChangeProfile() {
    this.props.onChangeProfileClick();
  }

  renderHeader() {
    const title = this.props.isManagingProfiles
      ? this.props.t("profile.manageTitle")
      : this.props.t("profile.selectTitle");

    return (
      <div
        className={classNames("profile-header", "page-header", {
          "profile-header--welcome": this.props.isWelcomeMessageVisible,
        })}
      >
        {this.props.isWelcomeMessageVisible && (
          <h1>{this.props.t("profile.welcomeTitle")}</h1>
        )}
        {this.props.isWelcomeMessageVisible ? (
          <h2>{title}</h2>
        ) : (
          <h1>{title}</h1>
        )}
      </div>
    );
  }

  renderFooterButtons() {
    if (this.props.isManagingProfiles) {
      return (
        <div
          className={classNames("profile-footer", {
            "profile-footer--editing": this.props.isDoneButtonVisible,
          })}
        >
          <SecondaryButton
            colorScheme="blue"
            label={this.props.t("profile.addProfile")}
            type="button"
            onClick={() => {
              this.handleEditProfile(null);
            }}
          />
          {/* We only want to show this button on the Account Options page NOT the Manage Profiles Modal */}
          {!this.props.isOpen && (
            <SecondaryButton
              colorScheme="blue"
              label="Switch Profile"
              type="button"
              onClick={this.handleChangeProfile}
            />
          )}

          {this.props.isDoneButtonVisible && (
            <PrimaryButton
              colorScheme="blue"
              label={this.props.t("profile.done")}
              type="button"
              onClick={this.handleLeaveManageMode}
            />
          )}
        </div>
      );
    }

    return (
      <div className="profile-footer">
        <SecondaryButton
          colorScheme="blue"
          label={this.props.t("profile.manageProfiles")}
          type="button"
          onClick={this.handleEnterManageMode}
        />
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.renderHeader()}
        {this.props.isLoadingProfiles ? (
          <div className="profile-container profile-container--loading container">
            <LoadingSpinner colorScheme="green" size="large" />
          </div>
        ) : (
          <div className="profile-container container">
            <BaseForm onSubmit={(values) => console.log(values)}>
              <ul className="icon-chooser">
                {this.props.profiles.map((profile) => (
                  <li className="icon-chooser-list__item" key={profile.id}>
                    <ProfileOption
                      icon={profile.icon}
                      id={profile.id}
                      isEditing={this.props.isManagingProfiles}
                      onEdit={this.handleEditProfile}
                      onSelect={this.handleSelectProfile}
                      title={profile.firstName}
                    />
                  </li>
                ))}
              </ul>
            </BaseForm>
            {this.renderFooterButtons()}
          </div>
        )}
      </div>
    );
  }
}

Profile.defaultProps = {
  isDoneButtonVisible: true,
  isOpen: false
};

Profile.propTypes = {
  isWelcomeMessageVisible: PropTypes.bool.isRequired,
  isDoneButtonVisible: PropTypes.bool,
  isLoadingProfiles: PropTypes.bool.isRequired,
  isManagingProfiles: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool,
  profiles: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      firstName: PropTypes.string,
      lastName: PropTypes.string
    })
  ).isRequired,
  onEditProfile: PropTypes.func.isRequired,
  onChangeProfileClick: PropTypes.func.isRequired,
  onEnterManageMode: PropTypes.func.isRequired,
  onLeaveManageMode: PropTypes.func.isRequired,
  onSelectProfile: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
};

export default (translate()(Profile));



// WEBPACK FOOTER //
// ./src/components/Profile.js